import { Stack, Heading } from 'braid-design-system';

import ListItem from '../ListItem/ListItem';

import AddIndustries from './AddIndustries';
import { usePreferencesIndustryField } from './usePreferencesIndustryField';

interface Props {
  industries: any[];
  refetch: () => void;
}

const Industries = ({ industries }: Props) => {
  const preferencesIndustryField = usePreferencesIndustryField(industries);

  return (
    <Stack space="medium">
      <Heading level="4">Industries</Heading>

      {preferencesIndustryField.selected.length > 0 && (
        <Stack space="small">
          {preferencesIndustryField.selected.map((industry) => (
            <ListItem
              key={industry}
              itemLabel={industry}
              remove={() => {
                preferencesIndustryField.onRemoveSingleIndustry(industry);
              }}
            />
          ))}
        </Stack>
      )}

      <AddIndustries
        industryGroupings={preferencesIndustryField.value}
        setIndustryGroupings={preferencesIndustryField.onChange}
      />
    </Stack>
  );
};

export default Industries;
